import actionTypes from '../constants/action-types';

const focusedElement = (state = null, action) => {
  switch (action.type) {
    case actionTypes.SET_FOCUSED_ELEMENT: {
      return action.payload.elementId;
    }

    case actionTypes.CONNECT_MAPPED_HTML:
    case actionTypes.BLUR_FOCUSED_ELEMENT: {
      return null;
    }

    default:
      return state;
  }
};

export default focusedElement;
